import * as React from "react";
import { forwardRef } from "react";
const SvgSupportSuccess = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("g", { id: "Iconsax/Linear/tickcircle" }, /* @__PURE__ */ React.createElement("path", { id: "Vector", d: "M7.75 12L10.58 14.83L16.25 9.17M12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22Z", stroke: "#05A35C", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" })));
const ForwardRef = forwardRef(SvgSupportSuccess);
export default ForwardRef;
